const actionRequired = (roles: string[], userRoles: string[]) => {
  return roles && roles.some ? roles.some(role => userRoles.includes(role)) : false;
};

const handlePri = (v: any, userRoles: string[]) => {
  const red =
    actionRequired(v.lbentry.primary || [], userRoles) && !v.primaryvalid;
  const deleted = !!parseInt(v.deleted);
  let pri: string = v.priby;
  let prir: string =
    v.lbentry.sign === "both"
      ? (v.status < 3 ? "Requires: " : "") + v.prirole
      : (v.status < 3 ? "Requires: " : "") + (v.prirole ? v.prirole : "");
  let color: string = !deleted
    ? !v.primaryvalid
      ? red
        ? "red"
        : "green"
      : "blue"
    : "gray";

  if (!v.lbentry.pritext && !v.lbentry.primary) {
    prir = "Optional: ";
    if (v.prirole) {
      prir = "Optional: " + v.prirole;
    }
  }

  if (v.status === 2) {
    color = !deleted
      ? !v.primaryvalid
        ? red
          ? "red"
          : "green"
        : "blue"
      : "gray";
  } else if (v.status < 2) {
    color = !deleted ? "blue" : "gray";
  }

  if (!pri && v.lbentry?.primary && parseInt(v.status) < 1000) {
    pri = "";
    if (v.lbentry.primary instanceof Array) {
      v.lbentry.primary.map(
        (n: any, i: number) => (pri += (i !== 0 ? " / " : "") + n),
      );
    } else {
      pri = v.lbentry.primary;
    }

    prir = v.status < 3 ? "Requires: " : "";
    color = !deleted ? (red ? "red" : "green") : "gray";
    if (!v.secondaryvalid) {
      color = !deleted
        ? !v.secondaryvalid
          ? red
            ? "red"
            : "green"
          : "blue"
        : "gray";
    }
  }

  if (v.status > 2) {
    color = !deleted ? "blue" : "gray";
  }

  if (parseInt(v.status) === 2 && v.lbentry.primary) {
    color = !deleted
      ? !v.primaryvalid
        ? red
          ? "red"
          : "green"
        : "blue"
      : "gray";
  }

  if (color === "blue") prir = prir.replaceAll("Requires: ", "");

  // NEW LOGIC =============================================
  if (v.status < 3) {
    if (v.lbentry.sign === "both") {
      // BOTH SIGNERS REQUIRED
      if (!v.primaryvalid) {
        prir = v.status < 3 ? "Requires: " : "";
        color = !deleted ? (red ? "red" : "green") : "gray";
      } else if (v.primaryvalid) {
        prir = v.status < 3 ? "" : "";
        color = !deleted ? "blue" : "gray";
      }
    }
    pri = "";

    if (!v.priby) {
      if (v.lbentry.primary instanceof Array) {
        v.lbentry.primary.map(
          (n: any, i: number) => (pri += (i !== 0 ? " / " : "") + n),
        );
      } else {
        pri = v.lbentry.primary;
      }
    }

    if (v.priby) {
      pri +=
        (prir.replace("Requires: ", "") ? " / " : "") +
        v.prirole +
        " " +
        v.priby;
    }
  }
  const priRoles = pri ? pri.split("\n").filter(role => !!role) : [];
  return { roles: priRoles, option: prir, color, date: v.primarydate };
};

const handleSec = (v: any, userRoles: string[]) => {
  const red =
    actionRequired(v.lbentry.secondary || [], userRoles) && !v.secondaryvalid;
  const deleted = !!parseInt(v.deleted);
  let sec: string = v.secby ? v.secby : "";
  let secr: string =
    v.lbentry.sign === "both"
      ? (v.status < 3 ? "Requires: " : "") + (v.secrole ? v.secrole : "")
      : (v.status < 3 ? "Requires: " : "") + (v.secrole ? v.secrole : "");
  let color: string = !deleted
    ? !v.secondaryvalid
      ? red
        ? "red"
        : "green"
      : "blue"
    : "gray";

  if (v.status === 2) {
    color = !deleted
      ? !v.secondaryvalid
        ? red
          ? "red"
          : "green"
        : "blue"
      : "gray";
  } else if (v.status < 2) {
    color = !deleted ? "blue" : "gray";
  }
  if (parseInt(v.status) < 3 && !sec && v.lbentry) {
    sec = "";
    if (v.lbentry.sectext) {
      secr = "Optional: ";
      sec = v.lbentry.sectext ? v.lbentry.sectext : "";
    } else {
      if (v.lbentry.secondary instanceof Array) {
        v.lbentry.secondary.map(
          (n: any, i: number) => (sec += (i !== 0 ? " / " : " ") + n),
        );
      } else {
        sec = v.lbentry.secondary ? v.lbentry.secondary : "";
      }
      secr = "Optional: ";
    }

    color = !deleted ? (red ? "red" : "green") : "gray";

    if (v.lbentry.sign && v.lbentry.sign === "both") {
      secr = v.status < 3 ? "Requires: " : "";
    }
  } else if (v.sign !== "both" && parseInt(v.status) > 2) {
    if (v.lbentry.secondary instanceof Array) {
      v.lbentry.secondary.map(
        (n: any, i: number) => (sec += (i !== 0 ? " / " : " ") + n),
      );
    } else {
      sec = v.lbentry.secondary ? v.lbentry.secondary : "";
    }
    secr = "Optional: ";
  }

  if (v.sign !== "both") {
    // override above logic, if secondary is optional
    !v.secondaryvalid && (secr = "Optional: ");
    color = deleted ? "gray" : v.secondaryvalid ? "blue" : "green";
  }
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-expect-error
  if (parseInt(v.status) === 2 && !v.lbentry.sign === "both") {
    color = !deleted
      ? !v.secondaryvalid
        ? red
          ? "red"
          : "green"
        : "blue"
      : "gray";
  }

  if (v.status > 2) {
    color = !deleted ? "blue" : "gray";
  }

  if (color === "blue") secr = secr.replaceAll("Requires: ", "");
  if (v.sign === "both" && !v.secondaryvalid) {
    secr = v.status < 3 ? "Requires: " : "";
    color = !deleted ? (red ? "red" : "green") : "gray";
  }

  // NEW LOGIC =============================================
  if (v.status < 3) {
    if (v.lbentry.sign === "both") {
      if (!v.secondaryvalid) {
        secr = v.status < 3 ? "Requires: " : "";
        color = !deleted ? (red ? "red" : "green") : "gray";
      } else if (v.secondaryvalid) {
        secr = v.status < 3 ? "" : "";
        color = !deleted ? "blue" : "gray";
      }
    }

    sec = "";
    if (!v.secby) {
      if (v.lbentry.secondary instanceof Array) {
        v.lbentry.secondary.map(
          (n: any, i: number) => (sec += (i !== 0 ? " / " : "") + n),
        );
      } else {
        sec = v.lbentry.secondary ? v.lbentry.secondary : "";
      }
    }
  }

  if (v.secby) {
    sec = v.secrole + " " + v.secby;
    secr = "";
  }
  const secRoles = sec ? sec.split("\n").filter(role => !!role) : [];
  return { roles: secRoles, option: secr, color, date: v.secondarydate };
};

export const handleRoles = (row: any, type: "pri" | "sec", role: string[]) => {
  switch (type) {
    case "pri":
      return handlePri(row, role);
    case "sec":
      return handleSec(row, role);
  }
};
